import { render, staticRenderFns } from "./modalInsalubridadeBase.vue?vue&type=template&id=6276e5ea&scoped=true&"
import script from "./modalInsalubridadeBase.vue?vue&type=script&lang=js&"
export * from "./modalInsalubridadeBase.vue?vue&type=script&lang=js&"
import style0 from "./modalInsalubridadeBase.vue?vue&type=style&index=0&id=6276e5ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6276e5ea",
  null
  
)

export default component.exports